import { render } from "./decline-icon.vue?vue&type=template&id=c34b1abe"
import script from "./decline-icon.vue?vue&type=script&lang=js"
export * from "./decline-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__